import { NOT_APPLICABLE } from 'constants/common'

type TxType = 'l2' | 'l1l2' | 'l2l1'

export const getTxTypeLabel = (type: TxType | Uppercase<TxType>) => {
  if (['L2', 'l2'].includes(type)) {
    return 'L2'
  }

  if (['L1L2', 'l1l2'].includes(type)) {
    return 'L1 to L2'
  }

  if (['L2L1', 'l2l1'].includes(type)) {
    return 'L2 to L1'
  }

  return NOT_APPLICABLE
}
